import { INIT_COORDS } from '../types';
export function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-core/dist/esm/actions/dragDrop/local/setClientOffset.js
// module id = 7022
// module chunks = 0